import { FC, MouseEventHandler, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'react-daisyui';
import { ArrowLeftStartOnRectangleIcon } from '@heroicons/react/24/outline';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { companyAdminNavData } from '@/layouts/CompanyAdmin/config-nav.tsx';
import { useTranslation } from 'react-i18next';

import { cn } from '@/utils/classNames.ts';

type NavbarProps = {
  onClick?: MouseEventHandler;
  className?: string;
}

const Navbar: FC<NavbarProps> = ({ onClick, className }) => {
  const { logout } = useAuthContext();
  const { t } = useTranslation();

  const logoutWithClick = useCallback<MouseEventHandler>(
    (e) => {
      logout();
      onClick?.(e);
    },
    [logout, onClick]
  );

  return (
    <Menu className={cn('space-y-2', className)}>
      {companyAdminNavData.map((item, i) => (
        <Menu.Item key={i}>
          <Link onClick={onClick} to={item.path} className="flex gap-3 items-center">
            <div className="text-2xl">{item.icon}</div>
            <span>{t(item.title)}</span>
          </Link>
        </Menu.Item>
      ))}
      <Menu.Item>
        <a className="flex gap-3 items-center" onClick={logoutWithClick}>
          <ArrowLeftStartOnRectangleIcon className="w-6 h-6" />
          <span>{t('button.logout')}</span>
        </a>
      </Menu.Item>
    </Menu>
  );
};

export default Navbar;

